import { render, staticRenderFns } from "./procurement_party_tender_results_row.vue?vue&type=template&id=6c400c98&scoped=true&"
import script from "./procurement_party_tender_results_row.vue?vue&type=script&lang=js&"
export * from "./procurement_party_tender_results_row.vue?vue&type=script&lang=js&"
import style0 from "./procurement_party_tender_results_row.vue?vue&type=style&index=0&id=6c400c98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c400c98",
  null
  
)

export default component.exports